import { useState, useEffect } from 'react';
import { apiFetch } from '@/services/api';

export interface TicketTier {
  name: string;
  price: number;
  description: string;
}

export interface FeaturedRally {
  id: string;
  title: string;
  description: string;
  meeting_datetime: string;
  meeting_location: [number, number];
  image_url?: string;
  ticket_tiers?: TicketTier[];
  created_at: string;
}

export const useFeaturedRally = () => {
  const [rally, setRally] = useState<FeaturedRally | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFeaturedRally = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await apiFetch<FeaturedRally>('/events/featured-rally/');
        
        if (response.data) {
          setRally(response.data);
        } else {
          setRally(null);
        }
      } catch (err: any) {
        console.error('Error fetching featured rally:', err);
        setError(err.error || 'Failed to fetch featured rally');
        setRally(null);
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedRally();
  }, []);

  return { rally, loading, error };
}; 